module.exports = __webpack_public_path__ + "static/media/dualBabyActive.699cb858.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualBabyActive.png
// module id = 596
// module chunks = 0